export default __webpack_public_path__ + "static/media/kid1.bf79774f.jpg";